module.exports = __webpack_public_path__ + "media/images/icon-time-b51df79240683f2f2f0a7f6cd462d5ea.svg";